interface AddressType {
  addresseeName: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zipcode: string | null;
}

const formattedAddressArray = (address: AddressType) => {
  const { addresseeName, address1, address2, city, state, zipcode } = address;

  // Validate: if all values are null, return empty array
  if (!addresseeName && !address1 && !address2 && !city && !state && !zipcode) {
    return [];
  }

  const formatted = [];
  if (addresseeName) formatted.push(addresseeName);
  if (address1) formatted.push(address1);
  if (address2) formatted.push(address2);
  if (city && state && zipcode) {
    formatted.push(` ${city}, ${state}, ${zipcode}`);
  }

  return formatted;
};

export default formattedAddressArray;
